export const UPDATE_DESTINATION_CODES_REQUEST = "UPDATE_DESTINATION_CODES_REQUEST";
export const UPDATE_DESTINATION_CODES_SUCCESS = "UPDATE_DESTINATION_CODES_SUCCESS";
export const UPDATE_DESTINATION_CODES_ERROR = "UPDATE_DESTINATION_CODES_ERROR";
